<section class="relative w-full">
  <div class="w-full h-72 lg:h-[50vh] bg-cover bg-center bg-no-repeat overflow-hidden relative" style="
      background: linear-gradient(
          180deg,
          rgba(25, 228, 224, 0.8) 0%,
          rgba(19, 24, 45, 0.8) 50%,
          rgba(10, 14, 31, 0.8) 100%
        ),
        url('https://cmax.pages.dev/assets/landing-page/banner-community.png');
    ">
    <div class="absolute bottom-0 left-0 w-full overflow-hidden z-0">
      <svg class="w-full h-[80px] sm:h-[120px]" viewBox="0 0 1440 120" preserveAspectRatio="none">
        <path d="M0,0 Q720,120 1440,0 L1440,120 L0,120 Z" fill="#0A0E1F" />
      </svg>
    </div>
  </div>
  <div class="relative z-10 mx-auto bg-[#1B223B] text-center text-white p-10 shadow-lg -mt-24" style="
      width: 90%;
      max-width: 1100px;
      top: -70px;
      border-top-right-radius: 8px;
      border-bottom-left-radius: 8px;
      clip-path: polygon(
        50px 0,
        100% 0,
        100% calc(100% - 50px),
        calc(100% - 50px) 100%,
        0 100%,
        0 50px
      );
    ">
    <div style="
        border: 2px solid white;
        padding: 20px;
        clip-path: polygon(
          50px 0,
          100% 0,
          100% calc(100% - 50px),
          calc(100% - 50px) 100%,
          0 100%,
          0 50px
        );
        padding: 20px;
      ">
      <div class="w-40 h-1 bg-cyan-400 mx-auto -mt-8 rounded-full"></div>

<h2 class="text-[13px] md:text-[32px] font-bold mt-6">
  Join Our Elite Community of Players & Achievers!
</h2>

<p class="text-[8px] md:text-[20px] mt-4 leading-relaxed">
  To create the ultimate social gaming experience, we’ve packed in features
  that keep every game session thrilling and seamless.
</p>

      <div class="border-[2px] border-[#19E4E0] rounded-full inline-block p-[4px] mt-4">
        <button (click)="RedirectToLogin()" type="submit"
          class="text-[6px] md:text-base px-8 py-[0.5rem] rounded-full shadow-md --button transition">
          Play Game
        </button>
      </div>
    </div>
  </div>
</section>
